import {
  getNameDescriptionTableColumn,
  getCopyWithContentTableColumn,
  getProjectTableColumn,
  getPublicScopeTableColumn,
  getTagTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import {
  getProviderTableColumn,
} from '../utils/columns'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        addLock: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
      }),
      getProviderTableColumn(),
      getCopyWithContentTableColumn({
        field: 'access_key_id',
        title: 'AK',
      }),
      getProjectTableColumn(),
      getPublicScopeTableColumn({
        vm: this,
        resource: 'bastion_hosts',
      }),
      getTagTableColumn({ onManager: this.onManager, resource: 'bastion_host', columns: () => this.columns }),
      getTimeTableColumn({
        field: 'created_at',
        title: this.$t('system.text_127'),
      }),
    ]
  },
}
